import { modalColors } from './colors'
import { ModalTheme } from './types'

const modalTheme: ModalTheme = {
  colors: modalColors,
}

export default modalTheme
